import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"

import { withStyles, ButtonBase, Grid } from "@material-ui/core"

const style = theme => ({
  previewButton: {
    display: "inline-block",
    background: "transparent",
    border: "none",
    padding: 0,
    margin: "0.5rem 0.5rem",
    width: 200,
    height: "auto",
    borderRadius: 4,
    boxShadow: "0 0 25px -5px rgba(0,0,0,0.3)",
  },
  thumbnail: {
    width: 200,
    height: 200,
    borderRadius: 4,
  },
})

const ThumbGrid = ({ images, handleOpen, classes }) => {
    // console.log("Thumbnails/ThumbGrid:");
    //  console.log("**********************************************************");
    //  console.log("images[0]");
    //  console.log(images[0]);
    //  console.log("**********************************************************");

    //  console.log("images.map( image => image.image)");
    //  console.log(images.map( image => image.image));

    if (images[0] == null || (typeof images[0].image == "string")) {
      return (
        <div>
        </div>
      )
     }

    return images.map((image, i) => (
    <Grid item key={i}>
      <ButtonBase onClick={handleOpen(i)} className={classes.previewButton}>
      <GatsbyImage
        image={image.image.childImageSharp.gatsbyImageData}
        alt=""
      />
      </ButtonBase>
    </Grid>
  ))
}

ThumbGrid.propTypes = {
  classes: PropTypes.object,
  images: PropTypes.array,
}
export default withStyles(style)(ThumbGrid)
